export default __webpack_public_path__ + "static/Check-out-some-butterflies-02fa2a41663cc4a9274b966e7019e63e.jpg";